import { useTestMode } from "@/lib/publicConfig";

/**
 * Pre-launch TEST MODE banner. Renders a fixed amber strip at the very top of
 * the app whenever the backend has APP_TEST_MODE=true (surfaced via
 * /api/public-config). Makes it unmistakable to any visitor/tester that this
 * is NOT the live production site. Removed automatically when the flag is off.
 */
export default function TestModeBanner() {
  const testMode = useTestMode();
  if (!testMode) return null;
  return (
    <div
      role="status"
      aria-label="Test mode notice"
      data-testid="test-mode-banner"
      className="w-full text-center text-[11px] sm:text-xs font-semibold tracking-[0.18em] uppercase py-1.5 px-3"
      style={{ background: "#b58a45", color: "#1a1a18" }}
    >
      ⚠ Pre-launch TEST MODE — payments may be live · not the production site
    </div>
  );
}
